var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import classNames from 'classnames';
import { IconButton } from '../../../../infra/dls/components/icon-button/icon-button';
import { HeadingXs, TextM } from '../../../../infra/dls/components/typography/typography';
import CloseIcon from '../../../../infra/dls/icons/close-icon.svg';
import { ActionBar } from '../action-bar/action-bar';
import { ColorPicker } from './color-picker';
import { getContrastColor, hexToHsl, hexToRgb, isHexColor } from './utils';
import { useEditableField } from '../../campaign-builder/hooks/use-editable-field';
import styles from './styles.module.scss';
import { getDefaultCtaColor } from '../../campaign-builder/hooks/use-setup-default-cta-color';
export var ColorPickerButton = function (_a) {
    var _b;
    var _c;
    var title = _a.title, _d = _a.darkerBorder, darkerBorder = _d === void 0 ? false : _d;
    var _e = useEditableField('ctaColor'), ctaColor = _e.field, setCtaColor = _e.setValue;
    var defaultColor = (_c = ctaColor === null || ctaColor === void 0 ? void 0 : ctaColor.value) !== null && _c !== void 0 ? _c : getDefaultCtaColor();
    var _f = useState(false), showColorPicker = _f[0], setShowColorPicker = _f[1];
    var _g = useState(!isHexColor(defaultColor)), invalidInputColor = _g[0], setInvalidInputColor = _g[1];
    var _h = useState({
        hsl: hexToHsl(defaultColor),
        hex: defaultColor,
        rgb: hexToRgb(defaultColor),
    }), color = _h[0], setColor = _h[1];
    var colorPickerButtonRef = useRef(null);
    var handleChangeColor = function (newColor) {
        var updatedColor = __assign(__assign({}, newColor), { hex: newColor.hex === 'transparent' ? '#000000' : newColor.hex });
        setCtaColor(updatedColor.hex);
        setColor(updatedColor);
    };
    var handleShowColorPicker = function (show) {
        setShowColorPicker(show);
        setInvalidInputColor(false);
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: classNames(styles['button-wrapper'], (_b = {},
                    _b[styles['darker-border']] = darkerBorder,
                    _b)), children: _jsx("button", { style: { backgroundColor: color.hex, color: getContrastColor(color.hex) }, ref: colorPickerButtonRef, onClick: function () { return handleShowColorPicker(!showColorPicker); }, className: styles['color-picker-button'], "data-color-picker-trigger": true, children: _jsx(TextM, { className: "text-strong", children: title }) }) }), _jsx(ActionBar, { getMountNode: function () { return colorPickerButtonRef.current; }, visible: showColorPicker, onClose: function () { return handleShowColorPicker(false); }, excludeFromOutsideClick: ['data-color-picker-trigger'], children: _jsxs("div", { children: [_jsxs("div", { className: styles['color-picker-title'], children: [_jsx(HeadingXs, { color: "primary", children: "Button color" }), _jsx(IconButton.L, { Icon: _jsx(CloseIcon, {}), onClick: function () { return handleShowColorPicker(false); } })] }), _jsx("div", { className: styles['color-picker-container'], children: _jsx(ColorPicker, { selectedColor: color, onSelectChange: handleChangeColor, onInputChange: function (value) { return setInvalidInputColor(!isHexColor("#".concat(value))); }, invalidInputColor: invalidInputColor }) })] }) })] }));
};
